class Languages {
    constructor() {}

    getAll() {
        return [
            { "code": "en", "name": "English", "nativeName": "English", "status": true },
            { "code": "af", "name": "Afrikaans", "nativeName": "Afrikaans", "status": false },
            { "code": "nl", "name": "Dutch", "nativeName": "Nederlands, Vlaams", "status": true },
            { "code": "fr", "name": "French", "nativeName": "français, langue française", "status": false },
            { "code": "ja", "name": "Japanese", "nativeName": "日本語 (にほんご／にっぽんご)", "status": false },
            { "code": "pt", "name": "Portuguese", "nativeName": "Português", "status": true },
            { "code": "es", "name": "Spanish", "nativeName": "español, castellano", "status": true },
            { "code": "sv", "name": "Swedish", "nativeName": "svenska", "status": false },
        ];
    }
}

export { Languages as default };
